var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubjectInfoNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25510",
    "data-name": "Group 25510",
    transform: "translate(-269 -469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Container_56x56",
    "data-name": "Icon/Container/56x56",
    transform: "translate(269 469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "campaign_black_24dp",
    transform: "translate(282 482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13601",
    "data-name": "Path 13601",
    d: "M0,0H30.043V30.043H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13602",
    "data-name": "Path 13602",
    d: "M22.029,12.763v2.5h5.007v-2.5Zm-2.5,8.274c1.2.889,2.766,2.065,4.006,2.992.5-.663,1-1.339,1.5-2-1.239-.926-2.8-2.1-4.006-3C20.527,19.7,20.026,20.373,19.525,21.037ZM25.033,6c-.5-.663-1-1.339-1.5-2-1.239.926-2.8,2.1-4.006,3,.5.663,1,1.339,1.5,2C22.229,8.106,23.794,6.942,25.033,6ZM4.5,10.259a2.511,2.511,0,0,0-2.5,2.5v2.5a2.511,2.511,0,0,0,2.5,2.5H5.755v5.007h2.5V17.77H9.511l6.259,3.755V6.5L9.511,10.259Zm14.4,3.755a5.608,5.608,0,0,0-1.878-4.193V18.2A5.561,5.561,0,0,0,18.9,14.014Z",
    transform: "translate(0.504 1.007)",
    fill: "#233588"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectInfoNormal);
export default __webpack_public_path__ + "static/media/subject-info-normal.92f90c5a7ab3e3415005899394580b32.svg";
export { ForwardRef as ReactComponent };